module.exports = __webpack_public_path__ + "static/img/home-bg.b00d17f5.png";